//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const OverridableNow: FeatureFlag = {"Id":"OverridableNow","Label":"(QA)Allow overriding what is considered the current datetime","Impact":"For QA. Allow setting the effective time for testing. NOT comprehensive.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
